<div class="profile-quick-search wpee-block">
  <div class="wpee-block-header">
    <h4 class="wpee-block-title">Quick Search</h4>
  </div>
  <div *ngIf="!loader" class="profile-quick-search-inner wpee-block-content">
    <form class="dspdp-form-horizontal dsp-form-container" [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="box-pedding dsp-space general-search">
        <ul class="edit-profile">

          <!-- Seeking Gender -->
          <li class="dspdp-form-group dsp-form-group">
            <span class="dspdp-control-label dsp-control-label dspdp-col-sm-3 dsp-sm-3">
              Seeking a:
            </span>
            <mat-form-field appearance="outline" class="full-width">

              <mat-select formControlName="see_gender">
                <mat-option value="">Select Gender</mat-option>
                <mat-option *ngFor="let gender of genderOptions" [value]="gender._id">{{ gender.name }}</mat-option>
              </mat-select>
              <!-- <mat-error *ngIf="form.controls['see_gender'].invalid && form.controls['see_gender'].touched">
                Please select a gender.
              </mat-error> -->
            </mat-form-field>
          </li>

          <!-- Age Selection -->
          <li class="dspdp-form-group dsp-form-group from-to-value">
            <span class="dspdp-control-label dsp-control-label dspdp-col-sm-3 dsp-sm-3 from-to-age">
              Age:
            </span>
            <span class="dspdp-col-sm-3 dsp-sm-3 dspdp-xs-form-group dsp-xs-form-group from-to-age-box">
              <mat-form-field appearance="outline" class="full-width">

                <mat-select formControlName="age_from" (selectionChange)="onFromAgeChange($event.value)">
                  <mat-option value="">From</mat-option>
                  <mat-option *ngFor="let age of ageOptions" [value]="age">{{ age }}</mat-option>
                </mat-select>
                <!-- <mat-error *ngIf="form.controls['age_from'].invalid && form.controls['age_from'].touched">
                  from age.
                </mat-error> -->
              </mat-form-field>

            </span>
            <span class="dspdp-col-sm-3 dsp-sm-3 from-to-age-box">
              <mat-form-field appearance="outline" class="full-width">

                <mat-select formControlName="age_to">
                  <mat-option value="">To</mat-option>
                  <mat-option *ngFor="let age of toageOptions" [value]="age">{{ age }}</mat-option>
                </mat-select>
                <!-- <mat-error *ngIf="form.controls['age_to'].invalid && form.controls['age_to'].touched">
                  to age.
                </mat-error> -->
              </mat-form-field>
            </span>
          </li>

          <!-- Country Selection -->
          <li class="dspdp-form-group dsp-form-group">
            <span class="dspdp-control-label dsp-control-label dspdp-col-sm-3 dsp-sm-3">
              Country:
            </span>
            <mat-form-field appearance="outline" class="full-width">

              <mat-select formControlName="country">
                <mat-option value="">Select Country</mat-option>
                <mat-option *ngFor="let country of countryOptions" [value]="country._id">
                  {{ country.name }}
                </mat-option>
              </mat-select>
              <!-- <mat-error *ngIf="form.controls['country'].invalid && form.controls['country'].touched">
                Please select a valid country.
              </mat-error> -->
            </mat-form-field>
          </li>

        </ul>
      </div>

      <!-- Submit Button -->
      <div>
        <a class="link-cover"></a>
        <button mat-raised-button color="primary" type="submit" class="submit">Submit</button>
      </div>
    </form>
  </div>
  <div *ngIf="!loader" class="wpee-block-footer">
    <a class="edit-profile-link" (click)="openAdvanceSearch()">Advanced Search</a>
  </div>
  <div [ngClass]="{ 'shine': loader }">

  </div>
</div>